import { FormDefaultAttributes, type FormConfig, type NumberConfig } from '@common';
import { useI18nInstance } from '@core';

export const SET_MEDIAN_FORM_CONFIG: FormConfig = {
  name: 'set-median-form',
  attributes: {
    ...FormDefaultAttributes.getFormDefaultAttributes()
  },
  children: [
    {
      name: 'median',
      component: 'text',
      attributes: {
        label: 'statistics.label.median',
        clearable: true
      },
      settings: {
        needTranslate: true,
        mask: {
          mask: Number,
          thousandsSeparator: ' '
        }
      },
      validators: [
        { validator: 'required' },
        {
          validator: 'min',
          settings: {
            formatBeforeValidation: (value: string) => {
              return +value.replaceAll(' ', '');
            },
            equalEnabled: false,
            invalidMessage: 'form.validator.min.greaterThanInvalidMessage',
            formatMin: (min: number) => {
              const { n } = useI18nInstance().global;
              return n(min, 'currency');
            }
          }
        },
        {
          validator: 'max',
          settings: {
            formatBeforeValidation: (value: string) => {
              return +value.replaceAll(' ', '');
            },
            equalEnabled: false,
            invalidMessage: 'form.validator.max.lessThanInvalidMessage',
            formatMax: (max: number) => {
              const { n } = useI18nInstance().global;
              return n(max, 'currency');
            }
          }
        }
      ]
    } as NumberConfig
  ]
};
